import { FC } from 'react';
import { Search } from 'ui/icons/action/Search';
import { useListContext } from './ListContext';
import { Actions, Header, SearchInput } from './styled';

type ListHeaderProps = {
  searchPlaceholder?: string;
};

export const ListHeader: FC<React.PropsWithChildren<ListHeaderProps>> = ({
  children,
  searchPlaceholder = 'Search items',
}) => {
  const { query, setQuery } = useListContext();
  return (
    <Header>
      <SearchInput
        placeholder={searchPlaceholder}
        value={query}
        Prefix={<Search />}
        onChange={setQuery}
      />
      {children && <Actions>{children}</Actions>}
    </Header>
  );
};
